import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../@types/filter";
import { Paginated } from "../../../@types/paginated";
import { apisiseci } from "../../api";
import { Priority } from "../../../@types/priority";
import { useDefaultSearchParams } from "../../../hooks/useSearchParams";
import { useCurrentOrgao } from "../../../hooks/useCurrentOrgao";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
    unidade?: string;
    ativo?: boolean;
    orgao?: string;
    orgao_id?: string;
};

export function usePriorityList(params?: Props) {
    const token = localStorage.getItem("gov_access_token_sso");
    const currentOrgaoId = useCurrentOrgao();
    const defaultParams = useDefaultSearchParams();
    params = { ...defaultParams, ...params };

    if (currentOrgaoId && !params.orgao) {
        params = { ...params, orgao_id: currentOrgaoId.toString() };
    }

    return useQuery<Paginated<Priority>, AxiosError<{ detail: string }>>({
        enabled: !!token,
        queryKey: ['priority', 'list', params, currentOrgaoId],
        queryFn: async () => {
            const response = await apisiseci.get<Paginated<Priority>>(
                "/cms/prioridades/",
                { headers: { Authorization: `Bearer ${token}` }, params }
            );
            return response.data;
        },
    });
}
